// IMPORTANT
// This file takes the common searchForm settings (common to both flights and hotels in  'common/searchFormSettings') and extends by adding methods specific to HOME and MODIFY search forms
!function(name, module, context){
	//>>excludeStart("requireTmpl", pragmas.requireTmpl);
	if(window.define) define('hotels/searchFormSettings',['hotels/validators','common/searchForm' ,  'hotels/bgSearch'], module)
		else
	//>>excludeEnd("requireTmpl");
context[name] = module(CT.settings.validators,CT.settings.commonSearchForm)
}('searchForm', function(Validators, sf){

	return $.extend(true, sf,{ // extend common search form settings
		initialize : function() {
			if(window.location.search.indexOf("ui=v3") !=-1 && !_.find(this.$el.elements,function(el){return el.name == "ui";})){
				this.$el.prepend('<input type="hidden" name="ui" value="v3" />');
			}

			$('#CheckInDate, #CheckOutDate').removeAttr('name')
			$('#FromDate').attr('name', 'chk_in')
			$('#ToDate').attr('name', 'chk_out')
			if(window.location.search.indexOf("utm_source") == -1 && window.location.search.indexOf("ct_hotelid") != -1){
				var hotelContUrl = "/hotels/jsonservice/hotel-content?ct_hotelid={{ct_hotelid}}"
			}else{
				var hotelContUrl = "/hotels/jsonservice/hotel-content?city={{city}}&state={{state}}&country={{country}}"
					if(window.enableOpaque && CT.subProd != "wg" && window.countryCode=='in' && window.product!="B2B"){
						hotelContUrl += "&op="+true	
					}
			}
			
			if(CT.settings.hotel.enableBgSearch){
				new CT.BgSearch({
					$field:$("#Tags"),
					url:hotelContUrl,
					//url:"/hotelstatic/json/hotelContent.json",
					ref:"hotelContentBgSearch",	
					ajaxBeforeSend: function( xhr , url , options) {
						if(window.isResultsPage)
							CT.cache[CT.settings.currentTab].eventsTimes[url.split('/').slice(-1)[0]] = [{s: new Date().getTime()}]; 
					}	
				});

				new CT.BgSearch({
					$field:$("#Tags"),
					url:"/hotels/jsonservice/city-images?city={{city}}&state={{state}}&country={{country}}",
					ref:"cityImagesBgSearch",
					onSet:function(data){
						//changing key value pair to id and images path
						var newJson = {};
						_.each(data.r, function(val,i){
							if(val.id){
								newJson[val.id] = [].concat(val.im);
							}
						});
						
						return newJson;
					}	
				});
			}
			
			
			this.addValidations();
			
			//$("body").removeClass("srp").addClass("home");
		},


		subscriptions : {
			'searchForm.update' : 'update'
		},


		render : function(){
			$('#Result').hide();
			$('#Home').show();
			$('#HomeLongForm').show();
			$(".city_seo_content").show()
		},


		update : function(){
			// same as renderSearchForm in hotels
		},



		addValidations : function(){
			var todaysDate = moment(), dateFormat = 'D MMM, YYYY', minDate = todaysDate.format(dateFormat), maxDate = todaysDate.add('years', 1).format(dateFormat), daysOffset = 1, checkinDateTag = this.$('.checkin_date'), checkoutDateTag = this.$('.checkout_date'),childAge=this.$('.childAge'), validatorObject = {}, el;
			var self = this;
			//upon validate success prevent default
			if(this.$el.length > 0) {
				if (!( el = this.$el.get(0)).validatesuccess)
					el.validatesuccess = this.validateSuccess;
				if(el.id === "SearchForm" || el.id==="HotelSearch"){
					el.validateerror=this.validateerror;
				}


				this.$el.get(0).beforevalidate = function(){

					if(!CT.widgets.validator.getConditions(".required")(checkinDateTag[0]) && CT.widgets.validator.getConditions(".required")(checkoutDateTag[0])) {
						checkinDateTag.addClass("required");
					}
					if(!CT.widgets.validator.getConditions(".required")(checkoutDateTag[0]) && CT.widgets.validator.getConditions(".required")(checkinDateTag[0])) {
						checkoutDateTag.addClass("required");
					}
					if(!CT.widgets.validator.getConditions(".required")(checkinDateTag[0]) && !CT.widgets.validator.getConditions(".required")(checkoutDateTag[0])) {
						checkinDateTag.removeClass("required");
						checkoutDateTag.removeClass("required");
					}

					(function($ele){
						$ele.find('.childAge').each(function(ind,ele){
							var validator = {},childAge = ele,$childAge = $(ele);
							if(childAge){
								childAge.errorTip = $childAge.parents(".row")[0];
					        /*	validator.elem = childAge;
					            validator.mess = "Please help us with the missing field.";
					            validator.errorTip = $childAge.parents(".row")[0];
					            validator.condition = CT.widgets.validator.getConditions(".required");
					            // validator Objects should be cleared as this is getting called before validate.
					            childAge.validatorObjects = [];
					            childAge.validatorObjects.push(validator);
					            */
					        }
					    });
					})(self.$el);


				};
			}
		},
		displayErrors : function($inpEle) {
			var errorElements = [];
			errorElements.push({elem:$inpEle.get(0), mess:CT.messages.hotel.SorryUnknwnLoc,name:"custom"});
			CT.widgets.validator.showErrors(this.$el, errorElements)
		},


		validateUrlParams : function(/* String */ urlParams){
			var data = _.deserialize(urlParams, ['ca']), urlUpdateParams;
			if(CT.app == 'dp') {
				urlUpdateParams = ['areaName', 'formatDate'];
			} else {
				urlUpdateParams = ['formatDate'];
			}
			// Update the params as needed in url
			_.each(urlUpdateParams, function(fn){
				Validators[fn](data)
			})
			// if(data.area!=""){
			// 	data.poi=data.area
			// 	data.area=""
			// }

			return data
		},






		/**
		 *  Fired when clicked on submit from and all form validations are passed:
		 *  a) Home page search form
		 *  b) Modify search form
*/
validateSuccess : function(e) {
	e.preventDefault();
	var formElement = e.srcElement;

	var cityN, that = this, $form = $(this), status = true, checkinDateTag = this.$('.checkin_date'), checkoutDateTag = this.$('.checkout_date');

	var _fireSubmit = function(status){
				if(this.formSubmitSuccessCallBack){// form specific callback (callbacks for modify search and main search form)
					this.formSubmitSuccessCallBack();
				}
				
				if(e.currentTarget.id == "HotelSearch"){
					var params = _.deserialize(this.$el.serialize())
					var todaysDate =moment(),chkinDate="",diffDate="",chkOutDate="",LOS="";
					if(params.chk_in != "" && params.chk_out != ""){
						chkinDate = moment(params.chk_in,"DD/MM/YYYY")
						diffDate = chkinDate.diff(todaysDate,'days');
						chkOutDate = moment(params.chk_out , "DD/MM/YYYY")
						LOS = chkOutDate.diff(chkinDate,'days');
					}

					if(CT.subProd == undefined){
						var url = "city="+params.city+"&country="+params.country+"&num_rooms="+params.num_rooms+"&D+X="+diffDate+"&LOS="+LOS
					}else{
						var url = "from="+params.city+"&country="+params.country+"&num_rooms="+params.num_rooms+"&D+X="+diffDate+"&LOS="+LOS
					}
					var category = 'Hotels_TR'
					CT.utils.helperFunctions.trackGAEventWrapper(category,'H_Modify_Search',url,'100');
				}
				
				if(status) {
					CT.widgets.placeholder.removeLabels($form[0]);
					if(CT.subProd == "wg"){
						$('body').addClass("weekend");
						if(window.altFilters == "true"){
							$('body').addClass("optiond");
						}else{
							$('body').removeClass("optiond");
						}
		    			//$(".mapHotel").hide();
		    			//$(".viewController").removeClass("col16").addClass("col20");
		    		}else{
		    			$('body').removeClass("weekend");
		    			$('body').removeClass("optiond");
		    		}
		    		
					var urltoSearchObj = this.validateUrlParams(this.$el.serialize().replace(/&/g, CT.utils.urlDelimiter));
					if($("#SearchTag").val()){
						urltoSearchObj["sort"]="tags"
						urltoSearchObj["view"]="list"
						urltoSearchObj["tagsFilter"]=$("#SearchTag").val()+"_tag";
					}
		    		/*if(window.CTHACKSTORE){
		    			urltoSearchObj.area = window.CTHACKSTORE.loc[0].name;
		    			urltoSearchObj.starFilter = window.CTHACKSTORE.star+"";
					}*/	
					var formatDate = function(date){
						var initial = date.split(/\//);
						var formatedDate = [ initial[1], initial[0], initial[2] ].join('/');
						return formatedDate;
					}
					// https://groups.cleartrip.ae/?city=San+Francisco+CA&CheckIn=12/15/2019&CheckOut=12/17/2019
					//for seven plus hotel selected
					if(urltoSearchObj.num_rooms == 7){
						var searchedLocation = [urltoSearchObj.hotelName,urltoSearchObj.poi,urltoSearchObj.area,urltoSearchObj.city,urltoSearchObj.state].filter(function(item){return item}).join(", ")
						var url ='https://groups.cleartrip.'+window.countryCode+'/Group-Rate/?City='+searchedLocation+
								'&CheckInDate1='+formatDate(urltoSearchObj.chk_in)+
								'&OutDate='+formatDate(urltoSearchObj.chk_out)
						window.open(url,'_blank');
					}else{
						CT.fire('url.update', [urltoSearchObj]) // create a tab in searchTab.js
					}			
					
					
					
					//CT.fire('url.update', [this.validateUrlParams(this.$el.serialize().replace(/&/g, CT.utils.urlDelimiter))]) // create a tab in searchTab.js
				   //Mixpanel Tracker for the search Button

				} 
				var tempClavertap = this.getClavertapEventDetail();
				var clavertapEventName = tempClavertap.clavertapEventName;

				if(CT.app=="hotel" && CT.subProd!="wg") {
			    
					var categorySelected=$("#Tags").attr("category");
					var locationSelected=$("#Tags").attr("locationSelected");
					var destinationCity = $("#City").val();
					var rank=$("#Tags").attr("rank")?$("#Tags").attr("rank"):"";
					var itemType= $("#Tags").attr("placetype") ? $("#Tags").attr("placetype") : "City";
					// if(itemType)
					// CT.utils.trackers.mixpanelTrackingData["locationSorterReferer"]="homePage";
						var adultVal = 0;
						var childVal = 0;
						for(var k=1;k<=Number(urltoSearchObj.num_rooms);k++){
							adultVal = adultVal +  Number(urltoSearchObj["adults"+k]);
							childVal =  childVal + Number(urltoSearchObj["children"+k]);
						}
					var check_InDate=urltoSearchObj.chk_in?urltoSearchObj.chk_in:"N/A";
					var check_OutDate=urltoSearchObj.chk_out?urltoSearchObj.chk_out:"N/A";
					//var childVal=parseInt(urltoSearchObj.children1)+(urltoSearchObj.children2?parseInt(urltoSearchObj.children2):0)
					//var adultVal=parseInt(urltoSearchObj.adults1)+(urltoSearchObj.adults2?parseInt(urltoSearchObj.adults2):0)
					var travellerInfostring=urltoSearchObj.num_rooms+" room(s), "+adultVal+" adult(s), "+(childVal!=0?childVal+(childVal==1?" child":" children"):" ");
					var travellerDetails=travellerInfostring;
				    // CT.utils.trackers.mixpanelTrackingData.destinationCity = destinationCity ? destinationCity:"N/A"
				    // CT.utils.trackers.mixpanelTrackingData.destinationCountryCode =$('#Country').val()?$('#Country').val():"N/A"
	               	
	                var roomNightsURl=_.deserialize(window.location.search)
	                var numOfRooms = "N/A", roomNights = "N/A", los = "N/A", dayOfCheckIn = "N/A";
	                if(roomNightsURl.chk_in && roomNightsURl.chk_out && roomNightsURl.num_rooms){
		                 var roomNgts = parseInt(roomNightsURl.num_rooms)*Math.abs(moment(roomNightsURl.chk_in,"DD/MM/YYYY").diff(moment(roomNightsURl.chk_out,"DD/MM/YYYY"),"days"));
		                 roomNights = String(roomNgts);
		                 numOfRooms = String(roomNightsURl.num_rooms);
		                 los = String(Math.abs(moment(roomNightsURl.chk_in,"DD/MM/YYYY").diff(moment(roomNightsURl.chk_out,"DD/MM/YYYY"),"days")));
		                 dayOfCheckIn = moment(roomNightsURl.chk_in, 'DD/MM/YYYY',true).format('dddd');
	                }
	                
	               
				    //cleverTap evnets for hotels
				   	CT.utils.trackers.clevertapGlobleData={
		                "platform":"Desktop",
		                "destinationCity":destinationCity ? destinationCity:"N/A",
						"selectedDestination": locationSelected ? locationSelected : "N/A",
		                "destinationCountry":$('#Country').val()?$('#Country').val():"N/A",
		                "marketNature": "N/A",
		                "dx":(roomNightsURl.chk_in && roomNightsURl.chk_out != "" && window.ctCurrentDate && window.ctCurrentDate != "" && CT.utils && CT.utils.diffDates) ? CT.utils.diffDates(window.ctCurrentDate , roomNightsURl.chk_in) : "N/A",
		                "rooms": numOfRooms,
		                "roomNights": roomNights,
		                "los": los,
		                "DayOfWeek_checkIn": String(dayOfCheckIn),
		                "pax": String(adultVal+childVal),
		                "numAdults":String(adultVal),
		                "numChild":String(childVal),
		                "childAge": urltoSearchObj.ca1 ? String(urltoSearchObj.ca1.join('+')) : "N/A",
		                "userSignedInStatus": CT.utils.readCTAuthCookie() ? "Yes" : "No"     
	            	};
				}
				var claverTapObj = tempClavertap.claverTapObj;
				claverTapObj["successResponse"] = "Success";
				claverTapObj["itemChanged"]= "N/A";
				CT.utils.trackers.eventData.pageLoadStartTime = Date.now();
			    CT.utils.helperFunctions.trackClaverTapEvtHotel(clavertapEventName, claverTapObj);
			}

			$(".tipsy").hide();

			checkinDateTag.removeClass("required");
			checkoutDateTag.removeClass("required");

			this.$el.find(".ui-autocomplete-input.keyValue").each(function(idx, inpEle) {
				$inpEle =  $(inpEle);
				if(($inpEle.val() !== "" && $inpEle.val() !== $inpEle.attr("placeholder")) && $("#City").val() === "") {
					(function ($ele) {
						Validators.checkForCityAvailability($ele).done(function(data){
							if(!Validators.isValidCity($ele, data)){
								that.displayErrors($ele);
								status= false;
							}
							_fireSubmit.call(that, status);
						});
					})($inpEle);	
				} else _fireSubmit.call(that, status);
			});
            //Mixpanel Tracker for the search Button
	     },

	     getClavertapEventDetail: function(){
	     		var clavertapEventName = '';
	     	 	if($('#Home.modifySearch').length > 0){
	            	clavertapEventName	= "Hotel_ModifySearch_Clicked";
			    }
			    else if($('.changeDatesForm').length > 0){
			    	clavertapEventName	= "Hotel_ModifySearch_Clicked";
			    }
			    else{
            		clavertapEventName = "Hotel_Search_Clicked";	
			    }
			    var chkinDate;
			    var params = _.deserialize(this.$el.serialize())
				if(params.chk_in != "" && params.chk_out != ""){
					chkinDate = moment(params.chk_in,"DD/MM/YYYY");
				}
				if(CT.utils.trackers.eventData.searchType != "recent"){
	            	CT.utils.trackers.eventData.searchType = chkinDate ? "date" : "dateless";
            	}
            	// Hack for calculating the time to load SRP since search was triggered.
            	window.timeToSearchSRP = Date.now();
	            var timeSpent = Date.now() - CT.utils.trackers.eventData.userSessionStart;
			    var claverTapObj = {
				    "searchCategorySelected": CT.utils.trackers.eventData.categorySelected,
				    "searchType": String(CT.utils.trackers.eventData.searchType),
				    "timeSpent": String(timeSpent),
				    "searchedItem": String(CT.utils.trackers.eventData.searchedString),
				    "lenSearchedItem": String(CT.utils.trackers.eventData.searchedString.length)
				};
				if (clavertapEventName === "Hotel_Search_Clicked") {
					// es6 way of merging objects!
					claverTapObj = Object.assign(claverTapObj, {
						"checkin_date": CT.cache[CT.settings.currentTab].searchParams.processed.chk_in ? new Date(moment(CT.cache[CT.settings.currentTab].searchParams.processed.chk_in, "DD/MM/YYYY").format("YYYY-MM-DD")) : "N/A",
						"checkout_date": CT.cache[CT.settings.currentTab].searchParams.processed.chk_out ? new Date(moment(CT.cache[CT.settings.currentTab].searchParams.processed.chk_out, "DD/MM/YYYY").format("YYYY-MM-DD")) : "N/A"
					});
				}
			    return {"clavertapEventName" : clavertapEventName, "claverTapObj" : claverTapObj};
	     },

		validateerror:function(err){
			var that=this;
			var errorMessage = [];
			_.each(err,function(data){
				errorMessage.push(data.mess + " is required.");
				if(data.mess.indexOf("Child") >=0 ) {
					that.$el.find(".noOfTraveller").trigger('focus');
				}
			});
			
            var temp = this.getClavertapEventDetail();
			var clavertapEventName = temp.clavertapEventName;
            var claverTapObj = temp.claverTapObj;
			claverTapObj["successResponse"] = errorMessage.join("+");
			claverTapObj["itemChanged"]= "N/A";

			CT.utils.helperFunctions.trackClaverTapEvtHotel(clavertapEventName, claverTapObj);
		}
	});

}, CT.settings)
;
